// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"c403aa8a","575":"bb956682","631":"9bc44aae","635":"214b6200","853":"408eaad3","953":"ee3d2982","991":"e57df286"}[chunkId] + ".chunk.js";
};